import styled from 'styled-components';
import { darken, getContrast, desaturate } from 'polished';

function getConstrastColor(color?: string) {
  if (!color) return '#fff';
  return getContrast(color, '#fff') > 4 ? '#dedede' : '#3d3d3d';
}

export const Container = styled.button<{ color: string }>`
  width: 100%;
  min-height: 35px;
  max-height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  font-size: 14px;
  font-weight: bold;
  background-color: ${({ color }) => color};
  color: ${({ color }) => getConstrastColor(color)};
  transition: 0.2s;

  &:hover {
    background-color: ${({ color }) => darken(0.1, color)};
  }

  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    background-color: ${({ color }) => desaturate(1, color)};
  }
`;
